export const PM_TYPE = {
  PRODUCT_MODEL: 'PRODUCT_MODEL',
  USER_EXPORTS: 'USER_EXPORTS'
}

export const EXTRA_PM_TYPES = [
  { type: 'basic', businessName: 'Basic Exports', child: [] },
  { type: 'bom', businessName: 'Bom Exports', child: [] }
]

export const PM_CHANGE_TABS = {
  ELEMENTS_TO_BE_ADDED: {
    key: 'elementsToBeAdded',
    label: 'Added elements',
    modificationType: 'ADDED'
  },
  ELEMENTS_TO_BE_REMOVED: {
    key: 'elementsToBeRemoved',
    label: 'Removed elements',
    modificationType: 'REMOVED'
  }
}

export const PM_CHANGE_TABS_PAC = {
  ELEMENTS_TO_BE_REMOVED: {
    key: 'elementsToBeRemoved',
    label: 'Removed elements',
    modificationType: 'REMOVED'
  }
}

export const PM_DELAY_INFO = {
  MISSING_PM_UPLOAD: {
    color: 'info',
    label: 'Not updated',
    infoText: 'Product Model not yet\n'
        + ' available from Windchill'
  },
  CORE_FAILED_TO_LOAD_PM: {
    color: 'error',
    label: 'Failed',
    infoText: 'Product Model failed to load\n'
        + ' from CoRE'
  },
  PI_PORTAL_FAILED_TO_UPDATE_PM: {
    color: 'error',
    label: 'Failed',
    infoText: 'Product Model failed to load\n'
        + ' into PI Portal.'
  }
}
